var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "addProductDiv" },
    [
      _c("div", { staticClass: "top" }, [
        _c("span", [_vm._v(_vm._s(_vm.resourceObj.nameCn))]),
        _c("span", [_vm._v(_vm._s(_vm.productObj.productNameCn))]),
      ]),
      _c("div", { staticClass: "buttton" }, [
        _c(
          "div",
          { staticClass: "leftTrip" },
          [
            _vm.resourceObj.state != 4
              ? _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                )
              : _vm._e(),
            _vm.resourceObj.state == 4
              ? _c(
                  "div",
                  _vm._l(
                    _vm.chenckBudgteObj.planDayList,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.dateFormatYMD(item.planDate, "-")) +
                                "  "
                            ),
                          ]),
                          _c("span", [
                            _vm._v("D" + _vm._s(item.planDay) + "："),
                          ]),
                          _vm._l(item.cityList, function (item1, index1) {
                            return _c("span", { key: index1 }, [
                              _vm._v(" " + _vm._s(item1.cityName) + " "),
                              index1 != item.cityList.length - 1
                                ? _c("span", [_vm._v("-")])
                                : _vm._e(),
                            ])
                          }),
                        ],
                        2
                      )
                    }
                  ),
                  0
                )
              : _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.checkList,
                      callback: function ($$v) {
                        _vm.checkList = $$v
                      },
                      expression: "checkList",
                    },
                  },
                  _vm._l(
                    _vm.chenckBudgteObj.planDayList,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { label: item.planDay },
                              on: { change: _vm.handleCheckChange },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateFormatYMD(item.planDate, "-")
                                  ) + "  "
                                ),
                              ]),
                              _c("span", [
                                _vm._v("D" + _vm._s(item.planDay) + "："),
                              ]),
                              _vm._l(item.cityList, function (item1, index1) {
                                return _c("span", { key: index1 }, [
                                  _vm._v(" " + _vm._s(item1.cityName) + " "),
                                  index1 != item.cityList.length - 1
                                    ? _c("span", [_vm._v("-")])
                                    : _vm._e(),
                                ])
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
          ],
          1
        ),
        _c("div", { staticClass: "right" }, [_vm._t("addProductRightDiv")], 2),
      ]),
      _c("add-link-product-dialog", { ref: "addLinkProduct" }),
      _c("div", { staticClass: "last" }, [
        _c("button", { on: { click: _vm.addBudget } }, [_vm._v("保存")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }